import * as store from '@attain-apps/fe/web/main/lib/store'

import * as models from './models'
import { State } from './state'

/**
 * Core actions for this feature
 */
// NOTE: intentionally missing return type so that type can be inferred
export function getActionsConfig() {
  return {
    /* eslint-disable sort-keys */
    show: store.actions.standalone({
      data: (input: models.ShowInput) => ({
        toasts: models.ShowInput.from(input),
      }),
      reducer: ({ state, data: { toasts } }): State =>
        State.add(state, ...toasts),
    }),
    dismiss: store.actions.standalone({
      data: store.actions.Data.asIs<{ id: models.Toast.Id }>(),
      reducer: ({ state, data: { id } }): State => State.dismiss(state, id),
    }),
    dismissAll: store.actions.standalone({
      data: store.actions.Data.NONE,
      reducer: ({ state }): State => State.dismissAll(state),
    }),
    clickAction: store.actions.standalone({
      data: store.actions.Data.asIs<{
        toastId: models.Toast.Id
        actionId: models.Toast.Action['id']
      }>(),
    }),
    autoDismissExpired: store.actions.standalone({
      data: store.actions.Data.asIs<{ id: models.Toast.Id }>(),
      reducer: ({ state, data: { id } }): State => State.dismiss(state, id),
    }),
    /* eslint-enable sort-keys */
  } as const satisfies store.actions.Config.Constraint<State>
}
